import io from "socket.io-client";
import config from "../config/config";
import { getAccessToken } from "./services/session";

let socketInstance = null;

export const getAppSocket = () => {
  if (!socketInstance) {
    socketInstance = io(config.baseURL, {
      transports: ["websocket", "polling"],
      withCredentials: true,
      reconnection: true,
      auth: (callback) => callback({ token: getAccessToken() || "" }),
    });
  }
  return socketInstance;
};
